import Filter from './Filter'

export default class StudentList extends Filter {
    filterComponent = import('@/views/components/filters/compoents/StudentFilterComponent.vue')

    static DC_TYPE = 'dc_type'

    static STATUS = 'status'

    static DIRECTION = 'direction'

    static PERIOD = 'quarter__period__id'

    static QUARTER = 'quarter'

    static GENDER = 'gender'

    fields = {
      [StudentList.DC_TYPE]: {
        label: 'Dc Type',
      },
      [StudentList.STATUS]: {
        label: 'Status',
      },
      [StudentList.DIRECTION]: {
        label: 'Direction',
      },
      [StudentList.PERIOD]: {
        label: 'Period',
      },
      [StudentList.QUARTER]: {
        label: 'Quarter',
      },
      [StudentList.GENDER]: {
        label: 'Gender',
      },
    }
}
